



























import {Component, Prop, Vue} from "vue-property-decorator";
import {deflate} from "zlib";

@Component({
  components: {},
})

export default class ChatDoc extends Vue {
  @Prop({default: () => []})
  type: string | undefined
  @Prop({default: () => []})
  fileDownloadUrl: string | undefined
  @Prop({default: () => []})
  isSent: string | undefined
  @Prop({default: () => []})
  avatarUrl: string | undefined
  @Prop({default: () => []})
  mes: string | undefined
  @Prop({default:() =>[]})
  filePreviewUrl: string | undefined

  imgSrc = ''
  openUrl(url: string){
    window.open(url)
  }

  selectImgSrc(type: string | undefined) {
    if (type == 'docx' || type == 'doc') {
      this.imgSrc = 'img/word.svg';
    } else if (type == 'pdf') {
      this.imgSrc = 'img/pdf.svg';
    } else if (type == 'cad') {
      this.imgSrc = 'img/cad.svg';
    } else if (type == 'cloud') {
      this.imgSrc = 'img/cloud.svg';
    } else if (type == 'css') {
      this.imgSrc = 'img/css.svg'
    } else if (type == 'excel') {
      this.imgSrc = 'img/excel.svg'
    } else if (type == 'ppt.svg') {
      this.imgSrc = 'img/ppt.svg'
    } else if (type == 'txt') {
      this.imgSrc = 'img/txt.svg'
    } else if (type == 'web') {
      this.imgSrc = 'img/web.svg'
    } else if (type == 'zip') {
      this.imgSrc = 'img/zip.svg'
    } else {
      this.imgSrc = 'img/zip.svg'
    }
  }

  private mounted() {
    this.selectImgSrc(this.type)
  }

}
